module.exports = __webpack_public_path__ + "img/Corp - Plano 12x - 01.ccabaad5.png";